export default "ui-chart-line{display:block}\n";